import React from 'react';
import ContactForm from '../components/ContactForm';
import Hero from '../components/Hero';
import About from '../components/About';
import WhatWeDo from '../components/WhatWeDo';
import WhatWeOffer from '../components/WhatWeOffer';
import OurProducts from '../components/OurProducts';
import Footer from '../components/shared/Footer';

function HomePage() {
  return (
    <div className="App">
      <Hero />
      <About />
      <WhatWeDo />
      <WhatWeOffer />
      <ContactForm />
      <Footer />
    </div>
  );
}

export default HomePage;
